exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.input-group-prepend[data-v-4f98654b] {\n  height: unset !important;\n.input-group-text[data-v-4f98654b] {\n    background-color: #fff !important;\n    border-radius: 5.5px 0 0 5.5px !important;\n}\n}\n", ""]);

